import { Redirect } from 'expo-router';

export default function KursiPlayLegacyDashboardRedirect() {
  return <Redirect href="/learn/creator" />;
}
